var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRouletteHistoryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v220h1300V0H0Z",
    fill: "#0E0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v220h1300V0H0Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v220h1300V0H0Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-96 422 -439) scale(442.722 1817.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB74BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(36.57441 -435.94545 1487.44437 124.79178 359 -78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E42626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRouletteHistoryDark);
export default __webpack_public_path__ + "static/media/bg-roulette-history__dark.bb3541e92f873784ad57795d49be5a8d.svg";
export { ForwardRef as ReactComponent };